<!-- Button -->

<div>
  <button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
      @if (showAvatar && user?.avatar) {
        <img
          class="w-7 h-7 rounded-full"
          [src]="user?.avatar"
          />
      }
      @if (!showAvatar || !user?.avatar) {
        <mat-icon
          [svgIcon]="'heroicons_outline:user-circle'"
        ></mat-icon>
      }
      <!-- <span
      class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
        [ngClass]="{
          'mr-px mb-px': !showAvatar || !user?.avatar,
          'bg-green-500': user?.status === 'online',
          'bg-amber-500': user?.status === 'away',
          'bg-red-500': user?.status === 'busy',
          'bg-gray-400': user?.status === 'not-visible'
        }"
    ></span> -->
  </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Signed in as</span>
      <span class="mt-1.5 text-md font-medium">{{ user?.username }}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <!-- <button mat-menu-item>
  <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  <span>Profile</span>
</button> -->
<button (click)="changePassword()" mat-menu-item>
  <span>Change Password</span>
</button>
<button (click)="changePhoneNumber()" mat-menu-item>
  <span>Change Phone Number</span>
</button>

<button (click)="changeUsername()" mat-menu-item>
  <span>Change Username</span>
</button>
@if (user?.driverId) {
  <button (click)="changePin()" mat-menu-item>
    <span>Change PIN</span>
  </button>
}
@if (user?.networkUserId) {
  <button (click)="changeMFA()" mat-menu-item>
    <span>Change MFA Settings</span>
  </button>
}

<mat-divider class="my-2"></mat-divider>
<button mat-menu-item (click)="signOut()">
  <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
  <span>Sign out</span>
</button>
</mat-menu>
</div>
